import posthog from 'posthog-js';

/**
 * PostHog for the hunts admin client (same project as the mobile apps and
 * the API's error middleware). Initialized once at import time from
 * main.tsx; production builds only, so local dev and tests stay quiet.
 *
 * Error tracking: `capture_exceptions` reports uncaught exceptions and
 * unhandled rejections. Person records line up with the backend because
 * both sides use the Clerk user id as the distinct id.
 */

// Public client key — shippable by design; events land in the shared
// DestinationTours project.
const POSTHOG_KEY = 'phc_G7UU0XPDnqPugGbEut6nPRCrmynAEVu5si06ZHW3FJX';
const POSTHOG_HOST = 'https://us.i.posthog.com';

export function initAnalytics(): void {
  if (!import.meta.env.PROD) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_exceptions: true,
    capture_pageview: 'history_change',
  });
}

/** Tie the PostHog person to the signed-in Clerk user. */
export function identifyUser(clerkUserId: string, email?: string): void {
  if (!import.meta.env.PROD) return;
  posthog.identify(clerkUserId, email ? { email } : undefined);
}

/** Clear the person association on sign-out. */
export function resetAnalytics(): void {
  if (!import.meta.env.PROD) return;
  posthog.reset();
}

/** Report a handled error with optional context. Never throws. */
export function captureError(error: unknown, properties?: Record<string, unknown>): void {
  if (!import.meta.env.PROD) return;
  try {
    const err = error instanceof Error ? error : new Error(String(error));
    posthog.captureException(err, properties);
  } catch {
    // Reporting must not make a bad situation worse.
  }
}
